import { createTheme } from "@mui/material/styles";

/**
 * Rebuilds palette shades (dark, light, contrastText) after branding colors change.
 */
export const withAugmentedPalette = (theme) => ({
  ...theme,
  palette: createTheme({ palette: theme.palette }).palette,
});
